function deleteConfirmation(
	title = 'Are you sure you want to delete this?',
	onConfirm = () => {
	},
	text = null,
	confirmButtonText = 'Yes, Delete!',
) {
	// noinspection JSUnresolvedVariable
	return Swal.fire({
		title: title,
		text: text,
		icon: 'warning',
		showCancelButton: true,
		confirmButtonColor: '#3085d6',
		cancelButtonColor: '#d33',
		confirmButtonText: confirmButtonText
	})
}

function swalConfirm(
	title = 'Are you sure you want to do this?',
	onConfirm = () => {
	},
	html = null,
	confirmButtonText = 'Yes',
	cancelButtonText = 'Cancel',
) {
	// noinspection JSUnresolvedVariable
	return Swal.fire({
		title: title,
		html: html,
		icon: 'info',
		showCancelButton: true,
		confirmButtonColor: '#3085d6',
		cancelButtonColor: '#d33',
		confirmButtonText: confirmButtonText,
		cancelButtonText: cancelButtonText,
	})
}

function handleAjaxSuccess(response, callback = data => {
	loading();

	// noinspection JSUnresolvedVariable
	if (data.redirectUrl) {
		window.location = data.redirectUrl;
	} else {
		window.location.reload();
	}
}) {
	// noinspection JSUnresolvedVariable
	Swal.fire({
		icon: 'success',
		text: response.data.message,
		timer: 2000,
	}).then(() => {
		if (callback) {
			callback(response.data);
		}
	});
}

function displayError(title, text) {
	// noinspection JSUnresolvedVariable
	return Swal.fire({
		title: title,
		text: text,
		icon: 'warning',
	})
}

export {deleteConfirmation, swalConfirm, handleAjaxSuccess, displayError};
